import React, { useState, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import RadioButton from 'js/components/RadioButton'
import CheckBox from 'js/components/CheckBox'

const Answers = ({ type, answers, onChange, selectedAnswers, questionId }) => {
  return (
    <div className="relative overflow-hidden text-left" style={{ height: 400 }}>
      <div className="flex h-full flex-col overflow-y-auto">
        {answers.map((answer, i) => {
          return (
            <div
              key={answer.title}
              className="flex shrink-0 grow border-t border-BorderSub px-30 py-24"
            >
              {type === 'radio' ? (
                <RadioButton
                  label={answer.title}
                  onChange={() => onChange(i)}
                  checked={selectedAnswers.includes(i)}
                  id={`q-${questionId}-control-${i}`}
                  name={`q-${questionId}-control-${i}`}
                />
              ) : (
                <CheckBox
                  label={answer.title}
                  onChange={() => onChange(i)}
                  checked={selectedAnswers.includes(i)}
                  id={`q-${questionId}-control-${i}`}
                  name={`q-${questionId}-control-${i}`}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

Answers.propTypes = {
  type: PropTypes.oneOf(['radio', 'check']).isRequired,
  answers: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedAnswers: PropTypes.array.isRequired,
  questionId: PropTypes.number,
}

export default function Question({ isLast, question, onNext }) {
  const [selectedAnswers, setSelectedAnswers] = useState([])
  const legendRef = useRef()
  useLayoutEffect(() => legendRef.current.focus(), [])

  const updateSelectedAnswers = (index) => {
    if (question.singleSelection) return setSelectedAnswers([index])

    if (selectedAnswers.includes(index)) {
      setSelectedAnswers(selectedAnswers.filter((i) => i !== index))
    } else {
      setSelectedAnswers([...selectedAnswers, index])
    }
  }

  const sendAnswers = () => {
    const answers = []

    selectedAnswers.forEach((answer) => {
      answers.push(question.answers[answer])
    })

    onNext(answers)
  }

  return (
    <fieldset style={{ translate: `${question.questionId}00% 0` }}>
      <legend className="sr-only" ref={legendRef} tabIndex="0">
        {question.title}
      </legend>
      <Answers
        type={question.singleSelection ? 'radio' : 'check'}
        questionId={question.questionId}
        answers={question.answers}
        onChange={(answer) => updateSelectedAnswers(answer)}
        selectedAnswers={selectedAnswers}
      />
      <button
        className={`
          type-upper-fat w-full bg-Brand px-20
          py-24 text-TypeConstant transition
          hover:bg-BrandDark disabled:bg-grey-superlight disabled:text-grey-lightest hover:disabled:bg-grey-superlight
        `}
        disabled={!selectedAnswers.length}
        onClick={sendAnswers}
      >
        {isLast ? (
          <FormattedMessage
            id="planquiz_seeResult"
            defaultMessage="See your result"
          />
        ) : (
          <FormattedMessage id="SignUp.next" defaultMessage="Next" />
        )}
      </button>
    </fieldset>
  )
}

Question.propTypes = {
  question: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired,
}
